import React from 'react';
import TabButton from './TabButton';

export const Tabs = ({
  className = '',
  items,
  currentValue,
  onClick,
}: {
  className?: string;
  items: { label: string; value: any }[];
  currentValue?: string | number;
  onClick: React.Dispatch<React.SetStateAction<string | number | undefined>>;
}) => {
  return (
    <div
      className={`${className} flex h-18 min-h-18 divide-x divide-grey-10 dark:divide-grey-80`}
    >
      {items.map((item, index) => (
        <div key={'tab-' + index} className="flex w-full">
          <TabButton
            title={item.label}
            value={item.value}
            className="w-full h-full text-center"
            activeClassName="border-b-4 border-primary"
            inactiveClassName="border-b border-grey-10 dark:border-grey-80"
            isActive={currentValue === item.value}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  );
};

export default Tabs;
